/* Fantastick V8.1.0 — mobile-first motif entry with shared page routing and editor diagnostics. */
(function (w) {
  'use strict';
  if (w.FantastickMotifWorld) { w.FantastickMotifWorld.init(document); return; }
  const J = w.FantastickJourney;
  const node = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  function initRoot(root) {
    if (root._fkw) return;
    const config = JSON.parse(root.querySelector('[data-fkw-config]').textContent);
    if (!J || typeof J.pageURL !== 'function') throw Error('Das vollständige Update mit fantastick-journey.js wird benötigt.');
    let catalog = w.FantastickMotifCatalog.prepare(config, []);
    const q = key => root.querySelector('[data-fkw-' + key + ']');
    const requestCard = root.querySelector('[data-fkm-request-template]')?.content.firstElementChild;
    const money = (value, currency = config.currency) => new Intl.NumberFormat(config.locale || 'de', { style: 'currency', currency }).format(value / 100);
    const removers = [];
    let motif = null, mode = 'single', limit = 24, selected = new Set(), busy = false, destroyed = false;
    const on = (n, name, cb) => { n.addEventListener(name, cb); removers.push(() => n.removeEventListener(name, cb)); };
    function status(message, error = false) { q('status').textContent = message || ''; q('status').classList.toggle('is-error', error); }
    function focus(n) { n.focus({ preventScroll: true }); n.scrollIntoView({ block: 'start', behavior: 'auto' }); }
    function picture(url, alt) {
      const img = node('img'); img.src = url; img.alt = alt; img.loading = 'lazy'; img.decoding = 'async'; return img;
    }
    function linkChecks(results = []) {
      const list = q('diagnostic-results');
      if (!config.designMode || !list) return;
      list.replaceChildren();
      (config.products || []).forEach((product, index) => {
        const item = node('li', 'fkw__diagnostic-item'), result = results[index];
        item.append(node('strong', '', product.title + ' · ID ' + product.id));
        item.append(node('p', '', 'Gelesenes Feld: ' + (product.configuratorLinkSource || 'keine gültige Seitenreferenz')));
        if (product.configuratorUrl) {
          try {
            const u = J.pageURL(product.configuratorUrl), a = node('a', '', 'Verknüpfte Seite öffnen: ' + u.pathname + u.search);
            a.href = u.href; a.target = '_blank'; a.rel = 'noopener'; item.append(a);
          } catch (_) { item.append(node('p', 'fkw__diagnostic-warning', 'Ungültiger Link. Eine Shop-Seitenreferenz verwenden.')); }
        }
        if (product.configuratorLinkStatus === 'conflict') {
          item.append(node('p', 'fkw__diagnostic-warning', 'Unterschiedliche Seiten: Das ursprüngliche Feld gewinnt (' + product.configuratorPrimaryUrl + '). Das V7.9-Feld zeigt auf ' + product.configuratorFallbackUrl + '. Bitte vergleichen und vereinheitlichen.'));
        } else if (product.configuratorLinkStatus === 'legacy_fallback') {
          item.append(node('p', 'fkw__diagnostic-warning', 'Übergang: Noch das V7.9-Feld in Verwendung. Dieselbe Seite in custom.configurator_page übernehmen, damit auch dein ursprünglicher Produktbutton darauf zeigt.'));
        } else if (/^invalid_/.test(product.configuratorLinkStatus || '')) {
          item.append(node('p', 'fkw__diagnostic-warning', 'Falscher Feldtyp: Eine einzelne Seitenreferenz wird benötigt, keine Liste und kein Textfeld.'));
        } else if (!product.configuratorUrl) item.append(node('p', 'fkw__diagnostic-warning', 'Keine Seite ausgewählt. Dieses Produkt wird Kunden in der Motivwelt noch nicht angeboten.'));
        if (result) {
          item.append(node('p', result.ok ? 'fkw__diagnostic-ok' : 'fkw__diagnostic-warning', result.ok ? '✓ ' + result.text : '[' + (result.code || 'FEHLER') + '] ' + result.text));
        }
        list.append(item);
      });
      if (!list.children.length) list.append(node('li', '', 'Bitte zuerst im Abschnitt die konfigurierbaren Produkte auswählen und speichern.'));
    }
    async function checkLinks() {
      if (busy) return;
      const productsToCheck = config.products || [], wanted = motif && motif.key, results = [];
      lock(true);
      try {
        for (let n = 0; n < productsToCheck.length; n++) {
          if (destroyed) return;
          q('diagnostic-status').textContent = 'Prüfe Seite ' + (n + 1) + ' von ' + productsToCheck.length + (wanted ? ' mit dem ausgewählten Motiv …' : ' …');
          try {
            const c = await J.inspectProduct(productsToCheck[n], wanted);
            results[n] = { ok: true, text: 'Passendes Produkt und genau ein Konfigurator gefunden. Version ' + c.configuratorVersion + ', Abschnitt ' + c.sectionId + (wanted ? '. Gewähltes Motiv ist freigegeben.' : '. Zur Motivprüfung erst ein Motiv in der Galerie auswählen.') };
          } catch (e) { results[n] = { ok: false, code: e.code, text: e.detail || e.message }; }
          if (!destroyed) linkChecks(results);
        }
        if (!destroyed) q('diagnostic-status').textContent = results.filter(r => r.ok).length + ' von ' + productsToCheck.length + ' Seiten erfolgreich geprüft. Änderungen an Produktdaten oder Vorlagen zuerst speichern, dann den Editor neu laden und erneut prüfen.';
      } finally { if (!destroyed) lock(false); }
    }
    function eligible() {
      return motif ? (config.products || []).filter(p => p.id && p.configuratorUrl && (!motif.hasProductRestriction || (motif.allowedProductIds || []).map(String).includes(String(p.id)))) : [];
    }
    function updateCount() {
      const count = selected.size;
      q('selected').textContent = count ? count + (count === 1 ? ' Produkt ausgewählt' : ' Produkte ausgewählt') : 'Wähle dein Produkt aus.';
      q('start').textContent = mode === 'single' ? 'Produkt gestalten' : 'Auswahl gestalten';
      q('start').disabled = busy || (mode === 'single' ? count !== 1 : count < 2);
    }
    function lock(value) {
      busy = value; root.setAttribute('aria-busy', String(value));
      root.querySelectorAll('button, input, select').forEach(n => {
        if (value) { n.dataset.fkwWasDisabled = String(n.disabled); n.disabled = true; }
        else { if ('fkwWasDisabled' in n.dataset) n.disabled = n.dataset.fkwWasDisabled === 'true'; delete n.dataset.fkwWasDisabled; }
      });
      updateCount();
    }
    function products() {
      const list = q('products'); list.replaceChildren();
      eligible().forEach(p => {
        const label = node('label', 'fkw__product');
        const input = node('input'); input.type = mode === 'single' ? 'radio' : 'checkbox'; input.name = 'fkw-product-' + config.sectionId;
        input.value = String(p.id); input.checked = selected.has(String(p.id)); input.disabled = !p.available;
        label.append(input); if (p.imageUrl) label.append(picture(p.imageUrl, ''));
        const text = node('span', 'fkw__product-copy'); text.append(node('strong', '', p.title));
        text.append(node('small', '', p.available ? 'ab ' + money(Number(p.price)) : 'Zurzeit nicht verfügbar'));
        label.append(text); list.append(label);
        input.addEventListener('change', () => {
          if (mode === 'single') selected.clear();
          if (input.checked) {
            if (selected.size >= Math.min(6, Number(config.maxProducts) || 4)) { input.checked = false; status('Du kannst bis zu ' + config.maxProducts + ' Produkte zusammen gestalten.', true); return; }
            selected.add(String(p.id));
          } else selected.delete(String(p.id));
          status(''); updateCount();
        });
      });
      if (!list.children.length) list.append(node('p', '', 'Für dieses Motiv sind gerade keine Produkte freigegeben. Bitte wähle ein anderes Motiv.'));
      q('share-wrap').hidden = mode !== 'set'; q('set-note').hidden = mode !== 'set'; updateCount();
    }
    function choose(m) {
      motif = m; selected.clear(); q('detail').hidden = false;
      q('chosen').replaceChildren(picture(m.imageUrl, m.label));
      q('detail-title').textContent = 'Dein Motiv: ' + m.label;
      products(); gallery(); status(''); focus(q('detail-title'));
    }
    function gallery() {
      const category = q('category').value, term = q('search').value.trim().toLocaleLowerCase(config.locale);
      const list = catalog.motifs.filter(m => (category === 'favorites' ? w.FantastickFavorites.has(m.key) : category === 'all' || m.categoryKeys.includes(category)) && m.label.toLocaleLowerCase(config.locale).includes(term));
      q('motifs').replaceChildren();
      list.slice(0, limit).forEach(m => {
        const button = node('button', 'fkw__motif'); button.type = 'button';
        button.setAttribute('aria-pressed', String(!!motif && motif.key === m.key));
        button.append(picture(m.thumbnailUrl || m.imageUrl, ''), node('span', '', m.label));
        button.addEventListener('click', () => choose(m));
        const card = node('div', 'fkw__motif-card'), heart = w.FantastickMotifUI && w.FantastickMotifUI.heart(m);
        card.append(button); if (heart) card.append(heart); q('motifs').append(card);
      });
      if (requestCard) q('motifs').append(requestCard.cloneNode(true));
      q('count').textContent = list.length ? list.length + (list.length === 1 ? ' Motiv' : ' Motive') : 'Keine passenden Motive gefunden.';
      q('more').hidden = limit >= list.length;
    }
    const view = w.FantastickJourneyView.mount(root, config, { status, lock });
    catalog.categories.forEach(c => { const o = node('option', '', c.label); o.value = c.key; q('category').append(o); });
    function refreshFavorites() {
      const select = q('category'); let option = select.querySelector('[data-fkw-favorites]');
      const all = w.FantastickFavorites.getAll();
      if (all.length && !option) { option = node('option'); option.value = 'favorites'; option.dataset.fkwFavorites = ''; select.prepend(option); }
      if (option) {
        if (!all.length) { if (select.value === 'favorites') select.value = 'all'; option.remove(); }
        else option.textContent = 'Meine Favoriten ♥ (' + catalog.motifs.filter(m => w.FantastickFavorites.has(m.key)).length + ')';
      }
      if (select.value === 'favorites') gallery();
      if (w.FantastickMotifUI) w.FantastickMotifUI.sync(root);
    }
    if (w.FantastickFavorites) { refreshFavorites(); removers.push(w.FantastickFavorites.subscribe(refreshFavorites)); }
    on(q('category'), 'change', () => { limit = 24; gallery(); });
    on(q('search'), 'input', () => { limit = 24; gallery(); });
    on(q('more'), 'click', () => { limit += 24; gallery(); });
    root.querySelectorAll('[data-fkw-mode]').forEach(r => on(r, 'change', () => { mode = r.value === 'set' && config.multiEnabled ? 'set' : 'single'; selected.clear(); products(); }));
    on(q('start'), 'click', async () => {
      if (busy || !motif) return;
      const chosen = eligible().filter(p => selected.has(String(p.id)) && p.available);
      if (!chosen.length || mode === 'set' && chosen.length < 2) return;
      lock(true); status('Deine Auswahl wird vorbereitet …');
      try {
        if (config.designMode) throw Error('Bitte öffne die Shop-Vorschau außerhalb des Theme-Editors, um die Gestaltung zu starten.');
        if (mode === 'single') {
          await J.inspectProduct(chosen[0], motif.key);
          const u = J.pageURL(chosen[0].configuratorUrl);
          ['fkc_set', 'fkc_item', 'fkc_entry', 'motif', 'mode', 'variant'].forEach(k => u.searchParams.delete(k));
          u.searchParams.set('fkc_motif', motif.key); J.navigate(u.href);
        } else {
          const s = await J.create({ products: chosen, motif, share: q('share').checked, currency: config.currency, locale: config.locale, worldUrl: w.location.href.split('#')[0], entrySectionId: config.sectionId, transferMode: 'explicit' });
          J.navigate(J.editorURL(s, s.items[0]));
        }
      } catch (e) { lock(false); status(e.message, true); focus(q('status')); }
    });
    if (config.designMode && q('check-links')) { on(q('check-links'), 'click', checkLinks); linkChecks(); }
    gallery();
    view.init();
    const deepMotif = new URLSearchParams(w.location.search).get('motif') || new URLSearchParams(w.location.search).get('fkc_motif');
    if (deepMotif && !config.designMode) {
      const entry = catalog.motifs.find(m => m.key === deepMotif || m.handle === deepMotif);
      if (entry) {
        if (new URLSearchParams(w.location.search).get('mode') === 'multi' && config.multiEnabled) { mode = 'set'; const radio = root.querySelector('[data-fkw-mode][value="set"]'); if (radio) radio.checked = true; }
        choose(entry);
      } else status('Dieses Motiv ist hier nicht mehr verfügbar. Bitte wähle ein anderes Motiv.');
    }
    if (w.FantastickSeason) removers.push(w.FantastickSeason.subscribe(config, () => {
      catalog = w.FantastickMotifCatalog.prepare(config, []);
      const select = q('category'), previousCategory = select.value; select.replaceChildren();
      const all = node('option', '', 'Alle Motive'); all.value = 'all'; select.append(all);
      catalog.categories.forEach(c => { const option = node('option', '', c.label); option.value = c.key; select.append(option); });
      select.value = catalog.categories.some(c => c.key === previousCategory) ? previousCategory : 'all'; refreshFavorites();
      if (motif && !catalog.motifs.some(m => m.key === motif.key)) { motif = null; selected.clear(); q('detail').hidden = true; status('Die Saison dieses Motivs ist beendet. Bitte wähle ein anderes Motiv.'); }
      gallery();
    }));
    root._fkw = { destroy() { destroyed = true; view.destroy(); removers.forEach(remove => remove()); delete root._fkw; } };
  }
  function init(scope) {
    const roots = Array.from(scope.querySelectorAll('[data-fkw]')); if (scope.matches && scope.matches('[data-fkw]')) roots.unshift(scope);
    roots.forEach(root => { try { initRoot(root); } catch (_) { const status = root.querySelector('[data-fkw-status]'); if (status) status.textContent = 'Die Motivwelt konnte nicht geladen werden. Bitte lade die Seite neu.'; } });
  }
  w.FantastickMotifWorld = { version: '8.1.0', init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true }); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-fkw]').forEach(root => root._fkw && root._fkw.destroy()));
})(window);
